export function validateNewPassword(password = "", confirmPassword = "") {
    if (!password || password.length < 6) {
      return { ok: false, error: "Password must be at least 6 characters long" };
    }
    if (password !== confirmPassword) {
      return { ok: false, error: "Passwords do not match" };
    }
    return { ok: true };
  }